import { Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import { Trans, useTranslation } from "react-i18next";
import { formatDateTime } from "@utils/dateFormat";
import { ITransaction } from "../interface/ITransactionHistory";
import { DetailsLayout } from "./DetailsLayout";
import { useGetPaymentDetails } from "./hook/useGetPaymentDetails";

interface IParams {
    paymentCorrelationTransactionUuid: ITransaction["paymentCorrelationTransactionUuid"];
}

export const PaymentDetails = (props: IParams) => {
    const { paymentCorrelationTransactionUuid } = props;
    const {
        paymentDetails,
        getPaymentDetailsState: { error, isLoading },
    } = useGetPaymentDetails(paymentCorrelationTransactionUuid);
    const { t } = useTranslation("payment");

    return (
        <DetailsLayout error={error} hasDetails={Boolean(paymentDetails)} isLoading={isLoading}>
            {paymentDetails && (
                <Fragment>
                    <Grid item xs={12}>
                        <Typography>
                            <Trans
                                i18nKey="paymentDetailsText"
                                ns="payment"
                                values={{
                                    partialDigits: paymentDetails.paymentMethod.partialDigits,
                                    paymentDatetime: formatDateTime(paymentDetails.paymentDatetime).toLocaleLowerCase(),
                                }}
                            />
                        </Typography>
                        <Typography color="secondary" variant="small">
                            {t("generatedFrom")}&nbsp;
                            {paymentDetails.paymentRunId ? t("paymentRun") : t("oneOffPayment")}
                        </Typography>
                    </Grid>
                    {paymentDetails.comments && (
                        <Grid item xs={12}>
                            <Typography color="primary">{t("details")}</Typography>
                            {paymentDetails.comments.map(({ comment }) => (
                                <Typography key={comment}>{comment}</Typography>
                            ))}
                        </Grid>
                    )}
                </Fragment>
            )}
        </DetailsLayout>
    );
};
